import ReactMarkdown, { Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { cn } from '@/lib/tailwind.utils'

// No rehypeRaw plugin, so react-markdown never renders raw HTML — nothing to sanitize.
const markdownComponents: Components = {
  h1: ({ children }) => <h1 className="text-base font-semibold mb-2">{children}</h1>,
  h2: ({ children }) => <h2 className="text-sm font-semibold mb-1.5">{children}</h2>,
  h3: ({ children }) => <h3 className="text-sm font-medium mb-1">{children}</h3>,
  p: ({ children }) => <p className="text-sm leading-relaxed mb-2 last:mb-0">{children}</p>,
  ul: ({ children }) => <ul className="list-disc pl-5 mb-2 text-sm">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-5 mb-2 text-sm">{children}</ol>,
  li: ({ children }) => <li className="mb-0.5">{children}</li>,
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  a: ({ children, href }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary underline underline-offset-2"
    >
      {children}
    </a>
  ),
  hr: () => <hr className="my-3 border-border" />,
  blockquote: ({ children }) => (
    <blockquote className="border-l-2 border-border pl-3 text-sm text-muted-foreground italic">
      {children}
    </blockquote>
  ),
  table: ({ children }) => (
    <div className="overflow-x-auto mb-2">
      <table className="w-full border-collapse text-sm">{children}</table>
    </div>
  ),
  th: ({ children }) => (
    <th className="border-b border-border px-2 py-1 text-left font-semibold">{children}</th>
  ),
  td: ({ children }) => <td className="border-b border-border px-2 py-1">{children}</td>,
}

type MarkdownRendererProps = {
  markdown: string
  className?: string
}

export const MarkdownRenderer = ({ markdown, className }: MarkdownRendererProps) => (
  <div className={cn('text-sm', className)}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
      {markdown}
    </ReactMarkdown>
  </div>
)
